import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-4176">
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-4177">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-4178" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-4179" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4180">
        <div className="flex items-start gap-4 mb-6" data-id="element-4181">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-4182" />
          <div className="flex-1" data-id="element-4183">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-4184" />
            <div className="space-y-2" data-id="element-4185">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-4186" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-4187" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-4188" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-4189" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4190">
          {[1, 2, 3].map(i => <div key={i} data-id="element-4191">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-4192" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-4193" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-4194">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-4195">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-4196">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-4197" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-4198">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-4199">
              <div className="flex justify-between items-center" data-id="element-4200">
                <div className="flex-1 space-y-2" data-id="element-4201">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-4202" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-4203" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-4204" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}